import React from 'react'

function AuthModelLogout() {
  return (
    <div>AuthModelLogout</div>
  )
}

export default AuthModelLogout